import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import FileSaver from 'file-saver';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PrintPDFRef = () => {

    const [load, setLoad] = useState(false);
    const pdfPrintData = useSelector(state => state.showRefState.pdfPrintData);
    const [openPdfPrintError, setOpenPdfPrintError] = useState(false);
    const { t } = useTranslation();

    const createPDF = useCallback(async () => {
        const dataToSend = pdfPrintData.length > 0 ? pdfPrintData : [];
        if (dataToSend.length > 0) {
            setLoad(true);
            try {
                const requestOpt = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        data: dataToSend,
                        language: localStorage.getItem('language'),
                        firm: localStorage.getItem('firm')
                    })
                };
                const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/viewRef/pdfData?pdfData`, requestOpt);
                const blob = await response.blob();
                FileSaver.saveAs(blob, 'References.pdf');
            } catch (error) {
                console.error("Failed to create PDF:", error);
            } finally {
                setOpenPdfPrintError(false)
                setLoad(false);
            }
        } else {
            setOpenPdfPrintError(true)
        }
    }, [pdfPrintData]);

    const handleCloseDialog = () => {
        setOpenPdfPrintError(false);
    };

    return (
        <div>
            {load ?
                <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Print PDF</h6>}>
                    <Button
                        style={{ width: 80, backgroundColor: 'rgba(204, 0, 0, 0.54)', marginBottom: 10, marginTop: 5 }}
                        onClick={createPDF}
                        variant="contained"
                        size="large"
                        color="primary"
                        startIcon={<HourglassEmptyIcon style={{ color: 'white' }} />}
                    />
                </Tooltip>
                :
                <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Print PDF</h6>}>
                    <Button
                        style={{ width: 80, backgroundColor: 'rgba(204, 0, 0, 0.54)', marginBottom: 10, marginTop: 5 }}
                        onClick={createPDF}
                        variant="contained"
                        size="large"
                        color="primary"
                        startIcon={<PictureAsPdfIcon style={{ color: 'white' }} />}
                    />
                </Tooltip>
            }
            <Dialog aria-labelledby="simple-dialog-title" onClose={handleCloseDialog} open={openPdfPrintError}>
                <Alert severity="warning">
                    <AlertTitle>Info</AlertTitle>
                    {t('search_ref.search_print_pdf')}
                </Alert>
            </Dialog>
        </div>
    );
};

export default PrintPDFRef;